import { ErrorData } from "web/api/apiRequestTypes";

import getErrorInfo from "web/utils/system/essentials/getErrorInfo";

const buildErrorMessage = (errorResponse: ErrorData) => {
  const additionalInfo = getErrorInfo(errorResponse);
  if (!additionalInfo || !Array.isArray(additionalInfo.violations)) {
    return null;
  }

  const { violations } = additionalInfo;

  if (violations.length === 0) {
    return null;
  }

  const messages = violations
    .map((v: any) => v.message)
    .filter(Boolean)
    .join(" ");

  return messages;
};

export default buildErrorMessage;
